// import React from 'react';

// const Datenschutz = () => (
//     <div className='datenschutz-wrapper'>
//         <div style={{ width: '1000px', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: '0 auto' }}>
//             <div style={{ display: 'flex', justifyContent: 'center' }}>
//                 <h1>Datenschutzerklärung</h1>
//             </div>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>Gegenstand der Datenschutzerklärung</h2>
//                 <p>
//                     Verantwortlich für den Betrieb der Website <a href="https://www.orange-drivers.at" target="_blank" rel="noopener noreferrer">www.orange-drivers.at</a> (nachfolgend "Website") ist die
//                 </p>
//                 <p>
//                     <strong>Fahrschule ORANGEdrivers GmbH</strong><br />
//                     Braitnerstraße 4, 2500 Baden<br />
//                     E‑Mail: tanja.dsgvo(at)orange-drivers.at
//                 </p>
//                 <p>
//                     Der Schutz Ihrer Privatsphäre bei der Benützung unserer Website ist uns ein großes Anliegen. Diese Erklärung gibt Auskunft darüber, welche personenbezogenen Daten bei Ihrem Besuch auf unserer Website zu welchen Zwecken von uns erhoben werden, wie wir die erhobenen personenbezogenen Daten nutzen und an wen wir die personenbezogenen Daten weiter übermitteln sowie welche Rechte Sie bezüglich der erhobenen personenbezogenen Daten haben.
//                 </p>
//                 <p>
//                     Wir weisen ausdrücklich darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E‑Mail) Sicherheitslücken aufweisen und nicht lückenlos vor dem Zugriff durch Dritten geschützt werden kann.
//                 </p>
//                 <p>
//                     Wie in jedem geschäftlichem Umgang fallen auch bei uns personenbezogene Daten wie z. B. Name, Adresse, E‑Mailadresse, Telefonnummer etc. an. Wir möchten Ihnen im Folgenden einen möglichst detaillierten Überblick darüber geben, was bei uns mit Ihren Daten geschieht und welche Rechte Sie darauf ausüben können.
//                 </p>
//                 <p>
//                     Wir, die Fahrschule ORANGEdrivers, Braitnerstraße 4, 2500 Baden, wissen Ihr Vertrauen zu schätzen und wenden Sorgfalt und Sicherheitsstandards an, um Ihre persönlichen Daten vor unbefugten Zugriffen zu schützen.
//                 </p>
//                 <p>
//                     So haben wir die folgenden Grundsätze zur Sammlung, Verwendung, Aufbewahrung, Übertragung, Offenlegung und Vernichtung personenbezogener Daten festgelegt:
//                 </p>
//             </section>

//             <section>
//                 <h3 style={{color:'var(--blue)'}}>Rechtmäßigkeit, Fairness und Transparenz</h3>
//                 <p>Personenbezogene Daten werden in Bezug auf die betroffene Person rechtmäßig, fair und transparent verarbeitet.</p>
//                 <h3 style={{color:'var(--blue)'}}>Zweckbeschränkung</h3>
//                 <p>Alle gesammelten personenbezogenen Daten müssen einen bestimmten, ausdrücklichen und rechtmäßigen Zweck haben.</p>
//                 <h3 style={{color:'var(--blue)'}}>Datenminimierung</h3>
//                 <p>Alle erfassten personenbezogenen Daten müssen angemessen, relevant und auf das beschränkt sein, was für die Zwecke, für die sie verarbeitet werden, erforderlich ist.</p>
//                 <h3 style={{color:'var(--blue)'}}>Richtigkeit</h3>
//                 <p>Alle erfassten personenbezogenen Daten müssen korrekt sein und, wenn nötig, auf dem neuesten Stand gehalten werden.</p>
//                 <h3 style={{color:'var(--blue)'}}>Speicherbeschränkung</h3>
//                 <p>Personenbezogene Daten dürfen nicht länger gespeichert werden als für die Zwecke, für welche sie verarbeitet werden bzw. im Rahmen von gesetzlichen Aufbewahrungs- oder Dokumentationspflichten.</p>
//                 <h3 style={{color:'var(--blue)'}}>Integrität und Vertraulichkeit</h3>
//                 <p>Personenbezogene Daten werden so verarbeitet, dass eine angemessene Sicherheit der personenbezogenen Daten, einschließlich des Schutzes vor unbefugter oder rechtswidriger Verarbeitung und vor unbeabsichtigtem Verlust, Zerstörung oder Beschädigung, durch geeignete technische oder organisatorische Maßnahmen gewährleistet ist.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>I. Name und Anschrift des Verantwortlichen</h2>
//                 <p>
//                     Verantwortliche Person: Frau Tanja Willixhofer<br />
//                     Geschäftsführung der Fahrschule ORANGEdrivers<br />
//                     Braitnerstraße 4, 2500 Baden<br />
//                     Festnetz: +43/(0)2252/87630<br />
//                     Mobil: +43 699 10637333<br />
//                     E‑Mail: tanja.dsgvo(at)orange-drivers.at
//                 </p>
//                 <p>Gemäß DSGVO und österreichischem Datenschutzgesetz (DSG) in der Fassung des Datenschutz-Anpassungsgesetzes 2018 und des Datenschutz-Deregulierungs-Gesetzes 2018 ist der Verantwortliche nicht verpflichtet, einen Datenschutzbeauftragten zu bestellen; auf eine freiwillige Bestellung wurde verzichtet.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>II. Allgemeines zur Datenverarbeitung</h2>
//                 <h3>II.a Umfang der personenbezogenen Datenerhebung</h3>
//                 <p>
//                     Personenbezogene Daten werden von uns generell nur im operativ notwendigen Umfang erhoben und gespeichert, um die von Ihnen gewünschten Leistungen zur Führerschein-Ausbildung abwickeln zu können, d. h. die Verarbeitung beinhaltet folgende Daten:<br />
//                     - Name, Adresse, Geschlecht<br />
//                     - E‑Mail, Telefonnummer<br />
//                     - Sozialversicherungs-Nummer, Geburtsdatum, Geburtsort, Geburtsland<br />
//                     - Firmenname, Kunden-Nummer<br />
//                     - Zahlungsdaten (Kontonummer, Bankleitzahl, IBAN, Name des Kreditinstituts, Name des Kontoinhabers, Kreditkartendaten)
//                 </p>
//                 <p>
//                     Bei Firmen als Kunden: Adress-, Kontakt- und Zahlungsdaten wie oben, zusätzlich Daten zu Ansprechpartnern (Telefon, Fax, E‑Mail); Produktinformationen; Daten zu Kauf- und Konsumverhalten, die von der betroffenen Person zur Verfügung gestellt wurden, oder erforderlich für die Auftragserfüllung, oder gesetzlich vorgeschrieben.
//                 </p>
//                 <p>
//                     Sollten Sie uns Zusatzdaten zu Personen (etwa als Visitenkarten) überreichen, werden diese sofort nach Prüfung der Korrektheit der Daten vernichtet. Sollten Sie uns Daten über Dritte Personen übergeben, gehen wir davon aus, dass Sie die schriftliche Einwilligung der Beteiligten eingeholt haben.
//                 </p>

//                 <h3>II.b Weitergabe personenbezogener Daten</h3>
//                 <p>
//                     Unter personenbezogenen Daten sind im Folgenden nur unsere Privat-Kunden und bei Firmen die Kontakt-Personen zu verstehen; bei Lieferanten sind die Kontaktpersonen gespeichert, und bei MitarbeiterInnen werden alle gesetzlichen und zur Administration notwendigen Daten erhoben und verarbeitet.
//                 </p>
//                 <p>Daten von Mitbewerbern werden von uns nicht verarbeitet. Wir geben grundsätzlich keine personenbezogenen Daten außer Haus, mit folgenden Ausnahmen:</p>
//                 <ul>
//                     <li>Finanztechnische Abwicklung (Steuerberatung, Inkassodienstleister)</li>
//                     <li>Gesetzliche Prüfungen</li>
//                     <li>Auftragsabwicklung, insbesondere Auslieferung</li>
//                 </ul>
//                 <p>Unsere Partner wurden von uns sorgfältig ausgewählt und sind uns gegenüber verpflichtet, vertraulich mit Ihren Daten umzugehen. Eine Vermarktung oder ein Verkauf Ihrer Daten findet nicht statt. Eine Zusammenführung persönlicher Daten mit anderen Datenquellen wird nicht vorgenommen.</p>

//                 <h3>II.c Rechtsgrundlage für die Verarbeitung</h3>
//                 <ul>
//                     <li><strong>Einwilligung:</strong> Art. 6 Abs. 1 lit. a DSGVO</li>
//                     <li><strong>Vertragserfüllung:</strong> Art. 6 Abs. 1 lit. b DSGVO</li>
//                     <li><strong>Rechtliche Verpflichtung:</strong> Art. 6 Abs. 1 lit. c DSGVO</li>
//                     <li><strong>Berechtigtes Interesse:</strong> Art. 6 Abs. 1 lit. f DSGVO</li>
//                 </ul>

//                 <h3>II.d Zweck der Datenverarbeitung</h3>
//                 <p>
//                     Gemäß unserem Geschäftsmodell werden personenbezogene Daten nur in dem Umfang verarbeitet, um:<br />
//                     a) Fahrkurse und Fahrstunden<br />
//                     b) Prüfungsvorbereitung und -durchführung<br />
//                     c) Administrative Abwicklungen<br />
//                     d) Gesetzliche Aufbewahrungspflichten<br />
//                     e) Nachweispflichten gesetzeskonform zu erfüllen und<br />
//                     f) Ein reibungsloser Ausbildungs- und Prüfungsablauf gewährleistet wird
//                 </p>

//                 <h3>II.e Datenlöschung und Speicherdauer</h3>
//                 <p>
//                     Die personenbezogenen Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch gesetzliche Vorschriften vorgesehen ist. Daten werden gesperrt oder gelöscht, wenn gesetzliche Aufbewahrungsfristen enden (z. B. BAO: 7 Jahre).
//                 </p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>III. Bereitstellung der Webpräsenz</h2>

//                 <h3>III.a Zweck der Webpräsenz</h3>
//                 <p>Unsere Website stellt unsere Angebote im Sinne von Art. 6 Abs. 1 lit. f DSGVO bereit.</p>

//                 <h3>III.b Datenerhebung Logfiles</h3>
//                 <p>
//                     Bei jedem Zugriff werden automatisiert folgende Daten protokolliert (nicht personenbezogen):<br />
//                     - Browsertyp und Version<br />
//                     - IP-Adresse bzw. reverse FQDN<br />
//                     - Datum und Uhrzeit des Zugriffs<br />
//                     - Referrer<br />
//                     - Aufgerufene Ressourcen
//                 </p>
//                 <p>Diese Daten dienen der Funktions- und Sicherheitsüberwachung und werden nach Analyse gelöscht.</p>

//                 <h3>III.c Datenerhebung Cookies</h3>
//                 <p>
//                     Cookies sind für Bestellvorgänge notwendig. Sie werden im Browser gespeichert und können jederzeit vom Nutzer gelöscht oder blockiert werden. Die Kontrolle liegt vollständig beim Nutzer.<br />
//                 </p>

//                 <h3>III.d Datenerhebung Google Analytics</h3>
//                 <p>
//                     Wir nutzen Google Analytics mit IP-Anonymisierung. Nutzer können das Tracking durch ein Browser-Plugin oder über einen Opt-Out-Link deaktivieren. Die Daten sind anonym und werden nicht mit anderen Google-Daten verknüpft.
//                 </p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>IV. Kontaktaufnahme</h2>
//                 <h3>IV.a Kontaktaufnahme via E-Mail</h3>
//                 <p>Eine Kontaktaufnahme über tanja.dsgvo(at)orange-drivers.at ist möglich. In diesem Fall werden die übermittelten personenbezogenen Daten gespeichert und gelöscht, sobald sie für die Bearbeitung der Anfrage nicht mehr erforderlich sind.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>V. Umfang der Datenerhebung bei Kontaktaufnahme</h2>
//                 <h3>V.a Zweck der Datenerhebung</h3>
//                 <p>Die Daten werden gem. Art. 6 Abs. 1 lit. a DSGVO verarbeitet und nicht an Dritte weitergegeben. Sie dienen ausschließlich der Bearbeitung Ihrer Anfrage.</p>

//                 <h3>V.b Umfang der Datenerhebung</h3>
//                 <p>Initiativ übermittelte Daten gelten als vom Kunden eingewilligt. Sie werden im Original der E-Mail gespeichert, nicht in Datenbanken eingepflegt.</p>

//                 <h3>V.c Rechtsgrundlagen</h3>
//                 <ul>
//                     <li>Einwilligung: Art. 6 Abs. 1 lit. a DSGVO</li>
//                     <li>Berechtigtes Interesse: Art. 6 Abs. 1 lit. f DSGVO</li>
//                     <li>Vertragserfüllung: Art. 6 Abs. 1 lit. b DSGVO</li>
//                 </ul>

//                 <h3>V.d Dauer der Speicherung</h3>
//                 <p>Die Daten werden gelöscht, sobald sie für den Zweck der Anfrage nicht mehr erforderlich sind oder Gewährleistungsfristen enden.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>VI. Fortgesetzte Einhaltung der Grundprinzipien</h2>
//                 <p>
//                     Sie haben jederzeit das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung Ihrer Daten. Wir haben interne Verfahren implementiert, um diese Rechte zu gewährleisten und gesetzliche Aufbewahrungsfristen zu beachten.
//                 </p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>VII. Rechte der betroffenen Personen</h2>
//                 <h3>VII.a Auskunftsrecht</h3>
//                 <p>Betroffene können binnen eines Monats Auskunft über ihre personenbezogenen Daten verlangen.</p>
//                 <h3>VII.b Verweigerung der Auskunft</h3>
//                 <p>Bei offenkundig unbegründeten oder exzessiven Anfragen kann ein angemessenes Entgelt erhoben oder die Anfrage abgelehnt werden.</p>
//                 <h3>VII.c Reaktionszeit</h3>
//                 <p>Antwort erfolgt binnen 30 Tagen nach Eingang und Identitätsprüfung.</p>
//                 <h3>VII.d Löschungspflicht</h3>
//                 <p>Sie können Löschung Ihrer Daten verlangen, wenn keine Rechtsgrundlage mehr besteht.</p>
//                 <h3>VII.e Information an Dritte</h3>
//                 <p>Wurde Ihre Daten öffentlich gemacht und zur Löschung verpflichtet, informieren wir Dritte, soweit technisch möglich.</p>
//                 <h3>VII.f Widerspruchsrecht</h3>
//                 <p>Sie können gem. Art. 21 DSGVO der Verarbeitung Ihrer Daten widersprechen.</p>
//                 <h3>VII.g Recht auf Unterrichtung</h3>
//                 <p>Verantwortlicher informiert Empfänger über Berichtigung oder Löschung Ihrer Daten.</p>
//                 <h3>VII.h Recht auf Datenübertragbarkeit</h3>
//                 <p>Sie können Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format erhalten.</p>
//                 <h3>VII.i Recht auf Einschränkung der Verarbeitung</h3>
//                 <p>Unter bestimmten Voraussetzungen können Sie die Einschränkung der Verarbeitung verlangen.</p>
//                 <h3>VII.j Widerrufsrecht</h3>
//                 <p>Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>VIII. Automatisierte Entscheidungen und Profiling</h2>
//                 <p>Sie haben das Recht, nicht einer ausschließlich auf automatisierter Verarbeitung beruhenden Entscheidung unterworfen zu werden.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>IX. Recht auf Beschwerde bei einer Aufsichtsbehörde</h2>
//                 <p>Unbeschadet anderer Rechtsbehelfe steht Ihnen das Beschwerderecht bei einer Aufsichtsbehörde zu.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>X. Risikoabschätzung und Mediation</h2>
//                 <p>
//                     Ihre Daten werden durch technische Maßnahmen geschützt, z. B.:
//                 </p>
//                 <ul>
//                     <li>Cascaded firewalls with locked down DMZ</li>
//                     <li>AES encrypted file systems</li>
//                     <li>Split horizon DNS with hardcoded upstream</li>
//                     <li>Switched network and MAC secured WLAN</li>
//                     <li>Encrypted offline RAID1 backups on-premises and off-premises</li>
//                     <li>TLS backed email exchange</li>
//                     <li>24/7 internal monitoring</li>
//                     <li>No single Windows machine connected to the Internet</li>
//                     <li>Unnamed additional measures</li>
//                 </ul>
//                 <p>Wir sind uns bewusst, dass Geheimdienste und andere Organisationen fortgeschrittene Möglichkeiten haben, Sicherheitsmechanismen zu überwinden.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>XI. Änderungen dieser Datenschutzerklärung</h2>
//                 <p>Technische Entwicklungen und rechtliche Änderungen können Anpassungen erfordern. Änderungen gelten ab der Veröffentlichung auf der Website. Mit der weiteren Nutzung der Website erklären Sie sich einverstanden.</p>
//             </section>

//             <section>
//                 <h2 style={{color:'var(--blue)'}}>XII. Disclaimer</h2>
//                 <p>
//                     Verlinkte Inhalte Dritter liegen außerhalb unseres Verantwortungsbereichs. Wir distanzieren uns von allen Inhalten, die nach der Linksetzung verändert wurden. Für Schäden oder illegale Inhalte haftet allein der Anbieter der jeweiligen Seite. Erkenntnisse über illegale Inhalte führen zur Entfernung der Links.
//                 </p>
//                 <p>Die vorstehenden Datenschutzhinweise basieren auf der Muster-Datenschutzerklärung der Anwaltskanzlei Weiß & Partner.</p>
//             </section>

//         </div>
//     </div>
// );

// export default Datenschutz;


import React, { useContext } from "react";
import { StaticPagesContext } from "../contexts/StaticPagesContext";

const Datenschutz = () => {
  const { getPage, loading, error } = useContext(StaticPagesContext);

  const page = getPage("datenschutz");

  if (loading) {
    return (
      <div className="datenschutz-wrapper">
        <div style={{ width: "1000px", margin: "0 auto" }}>
          <p>Lade Inhalte…</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="datenschutz-wrapper">
        <div style={{ width: "1000px", margin: "0 auto" }}>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="datenschutz-wrapper">
        <div style={{ width: "1000px", margin: "0 auto" }}>
          <p>Seite nicht gefunden.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="datenschutz-wrapper">
      <div>
        {page.title ? (
          <div className="static-page-title">
            <h1>{page.title}</h1>
          </div>
        ) : null}

        <div
          className="static-page-content"
          dangerouslySetInnerHTML={{ __html: page.content || "" }}
        />
      </div>
    </div>
  );
};

export default Datenschutz;
